export default __webpack_public_path__ + "static/media/apple_watch_6.6aa4dae1.png";